export const Msg = ({ m }) => {
  return (
    <div className="row mx-0 my-5 py-5">
      <center>{m}</center>
    </div>
  )
}

export const msg = (m) => {
  return (
    <div className="row mx-0 my-2 py-2">
      <center>{m}</center>
    </div>
  )
}
